<template>
  <div class="space-y-1">
    <button
      type="button"
      class="text-gray-300 hover:text-white group w-full flex items-center px-4 py-3 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-indigo-500"
      aria-expanded="false"
      @click="toggleGroup"
    >
      {{ label }}
      <svg
        class="text-gray-400 ml-auto h-5 w-5 transform group-hover:text-gray-300 transition-colors ease-in-out duration-150"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          v-if="open"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M19 9l-7 7-7-7"
        />

        <path
          v-else
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M9 5l7 7-7 7"
        />
      </svg>
    </button>
    <div v-show="open" class="bg-gray-800">
      <div>
        <SidebarNavigationGroupLink
          v-for="(item, childIdx) in children"
          :key="`group_item_${childIdx}`"
          :route="item.route"
          :label="item.label"
          :exact="item.exact"
          :tip="item.tip"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SidebarNavigationGroupLink from './SidebarNavigationGroupLink.vue';

export default {
  components: {
    SidebarNavigationGroupLink,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    children: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      open: false,
    };
  },
  created() {
    this.open = this.children.some((child) => {
      const { href } = this.$router.resolve(child.route);

      if (child.exact) {
        return href === this.$route.path;
      }

      return this.$route.path.startsWith(href);
    });
  },
  methods: {
    toggleGroup() {
      this.open = !this.open;

      this.$emit('toggle');
    },
  },
};
</script>
